// extracted by mini-css-extract-plugin
export default {"root":"leZIX_leZIX","floating":"Ecphz_Ecphz","loader":"zTBrP_zTBrP","load":"Wiqk__Wiqk_","local":"SV48u_SV48u","message":"JuUBB_JuUBB"};